
<template>
   <div class="container-fluid">
    <section id="page-header" class="about-header">
       <h2>#Know us</h2>
       <p>A E-commerce Platform Where Ukulima Bora Online Farmers Can Sell Their Farm Produce</p>
    </section>
    <section id="about-head" class="section-p1">
       <img src="@/assets/img/aboutimage.jpg" alt="Image of Ukulima Bora Online Farmers">
       <div>
           <h2>Background Info</h2>
           <p>In Kenya, agriculture plays a pivotal role in the economy, employing a significant portion of the population and contributing substantially to the nation's GDP. However, Ukulima Bora Online Farmers often face challenges when it comes to selling their farm produce efficiently. Traditional marketplaces can be fragmented and inefficient, resulting in reduced profitability for farmers and limited access to fresh, quality produce for consumers. The advent of e-commerce presents an opportunity to revolutionize the agricultural sector by creating a dedicated platform where Ukulima Bora Online Farmers can directly sell their produce to a wider customer base.</p>
           <br>
           <marquee bgcolor="#ccc" loop="-1" scrollamount="5" width="100%">A E-commerce Platform Where Ukulima Bora Online Farmers Can Sell Their Farm Produce</marquee>
       </div>
    </section>
    </div>
</template>
   
<style scoped>
   .feature-heading{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
</style>